import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CoolFarmDairyResultsType, CoolFarmService } from '~/api/services/coolFarm'
import Dialog from '~/components/Dialog'
import { Nullable } from '~/types'
import { handleErrors } from '~/utils/helpers'
import Results from './AnswerCoolFarm/Steps/Results'

interface Props {
  id: Nullable<string>
  handleClose: () => void
  uniqueId: Nullable<string>
  farmerId: string
}

const PreviewModal: React.FC<Props> = (props) => {
  const { id, handleClose, uniqueId } = props
  const { t } = useTranslation()

  const [submitPreviewData, setSubmitPreviewData] = useState<CoolFarmDairyResultsType>(null)
  const [isBusy, setIsBusy] = useState(false)

  useEffect(() => {
    if (id) {
      fetchPreviewData()
    }
  }, [id])

  async function fetchPreviewData() {
    setIsBusy(true)
    try {
      const response = await CoolFarmService.getResultsCoolFarm(id)
      setSubmitPreviewData(response.data)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Dialog
    isDialogOpen={Boolean(id)}
    isLoading={isBusy}
    closeOnEscape
    style={{ width: '80%', height: '90%' }}
    textHeader={t('GHG emission results for data collection {{id}}', { id: uniqueId })}
    textContent={<>
      {!isBusy && <Results results={submitPreviewData} />}
    </>}
    minHeight={'90%'}
    heightContent={'100%'}
    handleClose={() => handleClose()}
  />

}
export default PreviewModal